module.exports = __webpack_public_path__ + "static/media/lp-steps-1.78cf2c91.jpg";